<template>
  <svg
    width="160"
    height="167"
    viewBox="0 0 160 167"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.06"
      d="M79.6793 139.444C112.639 139.444 139.359 112.706 139.359 79.7222C139.359 46.7386 112.639 20 79.6793 20C46.7193 20 20 46.7386 20 79.7222C20 112.706 46.7193 139.444 79.6793 139.444Z"
      fill="url(#paint0_linear_10083_74210)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M116 33C116.552 33 117 33.3956 117 33.8836V50.1164C117 50.6044 116.552 51 116 51C115.448 51 115 50.6044 115 50.1164V33.8836C115 33.3956 115.448 33 116 33Z"
      fill="url(#paint1_linear_10083_74210)"
    />
    <rect x="110" y="48" width="12" height="13" rx="1" fill="#93C0F1" />
    <g filter="url(#filter0_d_10083_74210)">
      <path
        d="M89 51.2727C89 48.3483 92.0358 46.4124 94.6873 47.646L124.687 61.6035C126.098 62.2598 127 63.6744 127 65.2302V130C127 132.209 125.209 134 123 134H93C90.7909 134 89 132.209 89 130V51.2727Z"
        fill="url(#paint2_linear_10083_74210)"
      />
    </g>
    <rect
      opacity="0.24"
      x="97"
      y="68"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint3_linear_10083_74210)"
    />
    <rect
      opacity="0.5"
      x="97"
      y="81"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint4_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="97"
      y="93"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint5_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="97"
      y="106"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint6_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="97"
      y="118"
      width="9"
      height="8"
      rx="2"
      fill="url(#paint7_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="110"
      y="68"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint8_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="110"
      y="81"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint9_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="110"
      y="93"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint10_linear_10083_74210)"
    />
    <rect
      opacity="0.5"
      x="110"
      y="106"
      width="9"
      height="7"
      rx="2"
      fill="url(#paint11_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="110"
      y="118"
      width="9"
      height="8"
      rx="2"
      fill="url(#paint12_linear_10083_74210)"
    />
    <g filter="url(#filter1_d_10083_74210)">
      <path
        d="M56 20C56 17.7909 57.7909 16 60 16H86C88.2091 16 90 17.7909 90 20V130C90 132.209 88.2091 134 86 134H60C57.7909 134 56 132.209 56 130V20Z"
        fill="url(#paint13_linear_10083_74210)"
      />
    </g>
    <rect
      opacity="0.24"
      x="61"
      y="24"
      width="23"
      height="6"
      rx="2"
      fill="url(#paint14_linear_10083_74210)"
    />
    <rect
      opacity="0.1"
      x="61"
      y="36"
      width="23"
      height="5"
      rx="2"
      fill="url(#paint15_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="61"
      y="49"
      width="23"
      height="5"
      rx="2"
      fill="url(#paint16_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="61"
      y="61"
      width="23"
      height="5"
      rx="2"
      fill="url(#paint17_linear_10083_74210)"
    />
    <rect
      opacity="0.1"
      x="61"
      y="74"
      width="23"
      height="5"
      rx="2"
      fill="url(#paint18_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="61"
      y="86"
      width="23"
      height="5"
      rx="2"
      fill="url(#paint19_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="61"
      y="98"
      width="23"
      height="5"
      rx="2"
      fill="url(#paint20_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="61"
      y="111"
      width="23"
      height="5"
      rx="2"
      fill="url(#paint21_linear_10083_74210)"
    />
    <g filter="url(#filter2_d_10083_74210)">
      <path
        d="M37 64C37 61.7909 38.7909 60 41 60H71C73.2091 60 75 61.7909 75 64V130C75 132.209 73.2091 134 71 134H41C38.7909 134 37 132.209 37 130V64Z"
        fill="url(#paint22_linear_10083_74210)"
      />
    </g>
    <rect
      opacity="0.24"
      x="44.5254"
      y="66.4277"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint23_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="44.5254"
      y="79.1653"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint24_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="44.5254"
      y="91.9028"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint25_linear_10083_74210)"
    />
    <rect
      opacity="0.5"
      x="44.5254"
      y="104.641"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint26_linear_10083_74210)"
    />
    <path
      opacity="0.24"
      d="M46.8892 121.914C46.8892 120.809 47.7846 119.914 48.8892 119.914H55.9757V133.957H46.8892V121.914Z"
      fill="url(#paint27_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="57.6685"
      y="66.4277"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint28_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="57.6685"
      y="79.1653"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint29_linear_10083_74210)"
    />
    <rect
      opacity="0.5"
      x="57.6685"
      y="91.9028"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint30_linear_10083_74210)"
    />
    <rect
      opacity="0.24"
      x="57.6685"
      y="104.641"
      width="8.69383"
      height="7.27856"
      rx="2"
      fill="url(#paint31_linear_10083_74210)"
    />
    <path
      opacity="0.24"
      d="M55.9746 119.914H63.0612C64.1657 119.914 65.0612 120.809 65.0612 121.914V133.957H55.9746V119.914Z"
      fill="url(#paint32_linear_10083_74210)"
    />
    <defs>
      <filter
        id="filter0_d_10083_74210"
        x="67"
        y="36.2681"
        width="82"
        height="130.732"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74210"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74210"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10083_74210"
        x="34"
        y="5"
        width="78"
        height="162"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74210"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74210"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_10083_74210"
        x="15"
        y="49"
        width="82"
        height="118"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0117647 0 0 0 0 0.466667 0 0 0 0 1 0 0 0 0.16 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10083_74210"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10083_74210"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_10083_74210"
        x1="19.9981"
        y1="139.444"
        x2="139.443"
        y2="20.0844"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_10083_74210"
        x1="115"
        y1="50.9999"
        x2="118.951"
        y2="50.5609"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_10083_74210"
        x1="107.988"
        y1="42.9413"
        x2="107.988"
        y2="134.959"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_10083_74210"
        x1="96.9999"
        y1="75"
        x2="103.784"
        y2="66.2768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_10083_74210"
        x1="96.9999"
        y1="88"
        x2="103.784"
        y2="79.2768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_10083_74210"
        x1="96.9999"
        y1="100"
        x2="103.784"
        y2="91.2768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_10083_74210"
        x1="96.9999"
        y1="113"
        x2="103.784"
        y2="104.277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_10083_74210"
        x1="96.9999"
        y1="126"
        x2="104.945"
        y2="117.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_10083_74210"
        x1="110"
        y1="75"
        x2="116.784"
        y2="66.2768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint9_linear_10083_74210"
        x1="110"
        y1="88"
        x2="116.784"
        y2="79.2768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint10_linear_10083_74210"
        x1="110"
        y1="100"
        x2="116.784"
        y2="91.2768"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint11_linear_10083_74210"
        x1="110"
        y1="113"
        x2="116.784"
        y2="104.277"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint12_linear_10083_74210"
        x1="110"
        y1="126"
        x2="117.945"
        y2="117.062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint13_linear_10083_74210"
        x1="72.9889"
        y1="13.2705"
        x2="72.9889"
        y2="135.272"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint14_linear_10083_74210"
        x1="60.9996"
        y1="30"
        x2="63.9306"
        y2="18.7645"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint15_linear_10083_74210"
        x1="60.9996"
        y1="41"
        x2="63.0755"
        y2="31.4512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_10083_74210"
        x1="60.9996"
        y1="54"
        x2="63.0755"
        y2="44.4512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_10083_74210"
        x1="60.9996"
        y1="66"
        x2="63.0755"
        y2="56.4512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint18_linear_10083_74210"
        x1="60.9996"
        y1="79"
        x2="63.0755"
        y2="69.4512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint19_linear_10083_74210"
        x1="60.9996"
        y1="91"
        x2="63.0755"
        y2="81.4512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint20_linear_10083_74210"
        x1="60.9996"
        y1="103"
        x2="63.0755"
        y2="93.4512"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint21_linear_10083_74210"
        x1="60.9996"
        y1="116"
        x2="63.0755"
        y2="106.451"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint22_linear_10083_74210"
        x1="55.9876"
        y1="58.2883"
        x2="55.9876"
        y2="134.798"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FDFEFF" />
        <stop offset="0.9964" stop-color="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint23_linear_10083_74210"
        x1="44.5253"
        y1="73.7062"
        x2="51.6904"
        y2="65.1478"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint24_linear_10083_74210"
        x1="44.5253"
        y1="86.4438"
        x2="51.6904"
        y2="77.8854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint25_linear_10083_74210"
        x1="44.5253"
        y1="99.1813"
        x2="51.6904"
        y2="90.6229"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint26_linear_10083_74210"
        x1="44.5253"
        y1="111.919"
        x2="51.6904"
        y2="103.361"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint27_linear_10083_74210"
        x1="46.889"
        y1="133.957"
        x2="59.6989"
        y2="125.668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint28_linear_10083_74210"
        x1="57.6683"
        y1="73.7062"
        x2="64.8335"
        y2="65.1478"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint29_linear_10083_74210"
        x1="57.6683"
        y1="86.4438"
        x2="64.8335"
        y2="77.8854"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint30_linear_10083_74210"
        x1="57.6683"
        y1="99.1813"
        x2="64.8335"
        y2="90.6229"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint31_linear_10083_74210"
        x1="57.6683"
        y1="111.919"
        x2="64.8335"
        y2="103.361"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
      <linearGradient
        id="paint32_linear_10083_74210"
        x1="55.9745"
        y1="133.957"
        x2="68.7843"
        y2="125.668"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#006FFF" />
        <stop offset="1" stop-color="#0683FF" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup></script>
